// Versão: 1.00
// Data..: 2026-09-24
// Logo da Makweb que troca conforme o tema (clara em fundo claro, clara-invertida no escuro).

import { useTheme } from '../context/ThemeContext.js';

// logo-light.png: "MakWeb" azul+preto (ideal em fundo claro).
// logo-dark.png:  "Mak" azul + branco (ideal em fundo escuro).
export function Logo({ height = 30 }: { height?: number }) {
  const { theme } = useTheme();
  const src = theme === 'dark' ? '/logo-dark.png' : '/logo-light.png';
  return <img src={src} alt="Makweb" height={height} style={{ height, width: 'auto', display: 'block' }} />;
}
